
import store from '../store'
import Utility from '@/shared/utility'
import {getHttpsCallable} from "@/shared/firebase_utils";

export default {
    updateSubscriptionDetails: async function() {
        const businessProfile = store.getters.businessProfile;
        const getSubscriptionDetails = getHttpsCallable('getSubscriptionDetails');
        const response = await getSubscriptionDetails({ subscriptionId: businessProfile.subscriptionId });
        const subscriptionDetails  = response.data;
        console.log(subscriptionDetails);
        const subscriptionStatus = subscriptionDetails.status;
        const nextInvoiceAmount = subscriptionDetails.upcoming_invoice.amount_due;
        const noOfEmployees = subscriptionDetails.current_quantity;
        const nextInvoiceCreationDate = Utility.stripeToJSDate(subscriptionDetails.upcoming_invoice.created);
        const plan = subscriptionDetails.plan;
        if(businessProfile.subscriptionStatus != subscriptionStatus || businessProfile.nextInvoiceAmount != nextInvoiceAmount || businessProfile.nextInvoiceCreationDate.toDate().getTime() != nextInvoiceCreationDate.getTime() || businessProfile.noOfEmployees != noOfEmployees) {
            console.log('subscription details changed');
            await store.dispatch('updateBusinessProfileDetails', {
                subscriptionStatus: subscriptionStatus,
                nextInvoiceAmount: nextInvoiceAmount,
                nextInvoiceCreationDate: nextInvoiceCreationDate,
                // noOfEmployees: noOfEmployees,
            });
        } else {
            console.log('subscription details did not change');
        }
    },
}